import React from "react";
import moment from "moment";

const formatDate = (date) => {
  if (!date) {
    return "-";
  }
  const parsed = moment(date, ["M/D/YYYY", "MM/DD/YYYY", "YYYY-MM-DD"], true);
  return parsed.isValid() ? parsed.format("MMM DD, YYYY") : date;
};

const getDateTime = (date) => {
  const parsed = moment(date, ["M/D/YYYY", "MM/DD/YYYY", "YYYY-MM-DD"], true);
  return parsed.isValid() ? parsed.valueOf() : 0;
};

const formatNumber = (value, options = {}) => {
  if (value === "" || value === null || value === undefined) {
    return "-";
  }
  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return value;
  }
  return numeric.toLocaleString(undefined, options);
};

const Insiders = ({ data }) => {
  const insiders = (data && data.insiders ? data.insiders : [])
    .slice()
    .sort((a, b) => getDateTime(b.transaction_date) - getDateTime(a.transaction_date))
    .slice(0, 100);

  if (!insiders.length) {
    return <div className="text-center p-5">No insider transactions available.</div>;
  }

  return (
    <div className="mi-regulatory-table-wrap mt-4 px-3">
      <div className="table-responsive mi-regulatory-table-scroll">
        <table className="table mi-regulatory-table mi-insiders-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Shareholder</th>
              <th>Relationship</th>
              <th>Type</th>
              <th>Transacted Shares</th>
              <th>Price ($)</th>
              <th>Value($)</th>
              <th>Total Shares Held After</th>
            </tr>
          </thead>
          <tbody>
            {insiders.map((item) => (
              <tr key={item.id || `${item.owner}-${item.transaction_date}-${item.sec_form4_link}`}>
                <td>
                  {item.sec_form4_link ? (
                    <a href={item.sec_form4_link} target="_blank" rel="noopener noreferrer">
                      {formatDate(item.transaction_date)}
                    </a>
                  ) : (
                    <>{formatDate(item.transaction_date)}</>
                  )}
                </td>
                <td>{item.owner || "-"}</td>
                <td>{item.relationship || "-"}</td>
                <td>{item.transaction || "-"}</td>
                <td>{formatNumber(item.shares)}</td>
                <td>{formatNumber(item.cost, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                <td>{formatNumber(item.value)}</td>
                <td>{formatNumber(item.shares_total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Insiders;
